const parseQueryString = require("../dom/parseQueryString");
const parseJsonBoolean = require("../dom/parseJsonBoolean");

/**
 * @param queryString {string}
 * @return {null | PreferenceCenterOptions}
 */
module.exports = function getPreferenceCenterOptionsFromQueryString(queryString) {
    const params = parseQueryString(queryString);

    /**
     * @type {PreferenceCenterOptions}
     */
    return {
        email: params["email"] || "",
        marketingSMSOptIn: parseJsonBoolean(params["87602"] || "false"),
        eventsActivateConferenceEmail: parseJsonBoolean(params["46039"] || "false"),
        webinarsResourcesEmail: parseJsonBoolean(params["46042"] || "false"),
        newslettersEmail: parseJsonBoolean(params["46040"] || "false"),
        productNewsEmail: parseJsonBoolean(params["46041"] || "false"),
        blogEmail: parseJsonBoolean(params["46038"] || "false"),
        phoneNumber: (params["phoneNumber"] || "").replace(" ", "+"),
        country: params["itblInternal.phoneCountry"] || "",
    };
}
